import React from 'react';
import Spinner from 'react-spinkit';
import './full-screen-carousel-item.scss';
import { setInterval } from 'timers';
import { getQualityFlag, getMuteFlag } from '../../pages/utils';
import VideoPlayer from '../VideoPlayer';

export default class Artwork extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      artwork: props.artwork,
      hasSubscription: props.hasSubscription,
      mute: getMuteFlag(),
      highquality: getQualityFlag()
    };
  }

  componentDidMount() {
    this.props.setCurrentArtworkId(this.props.artwork.id);
    this.interval = setInterval(() => {
      if (this.state.mute != getMuteFlag()) {
        this.setState({
          mute: getMuteFlag()
        });
      }
    }, 3000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentWillReceiveProps({ artwork, hasSubscription }) {
    this.setState({ artwork, hasSubscription });
    if (artwork.id !== this.props.currentId && this.props.currentId !== undefined)
      this.props.setCurrentArtworkId(artwork.id);
  }

  render() {
    const { artwork } = this.state;
    const artist = artwork?._embedded?.artist;
    return (
      <div className="full-screen-carousel-item">
        <div className="full-screen-carousel-item__image">
          <VideoPlayer
            videoUrl={this.props.isCurrent ? artwork.media.video.dash : null}
            posterUrl={artwork.media.image.low.landscape}
            artistName={`${artist?.givenName} ${artist?.surname}`}
            artworkName={artwork.name}
            showLogo={!this.props.hasSubscription}
            showDebug={false}
            muted={this.state.mute}
            subscription={this.props.hasSubscription}
          />
        </div>
      </div>
    );
  }
}
